module.exports = __webpack_public_path__ + "static/media/image2.69ee0f06.png";